import "bootstrap/dist/css/bootstrap.min.css";
import "./style";
import App from "./components/app";

export default App;
